import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export const MeshTooltip = withStyles(theme => ({
  tooltip: {
    fontSize: theme.typography.fontSize,
  },
}))(Tooltip);
